import {
  Component,
  EventEmitter,
  Input,
  OnDestroy,
  OnInit,
  Output,
} from '@angular/core';
import { debounceTime, Subject, Subscription } from 'rxjs';

import { TrackerCellModel } from '../tracker-manager/tracker-manager.service';

@Component({
  // eslint-disable-next-line @angular-eslint/component-selector
  selector: 'msd-tracker-cell',
  templateUrl: './tracker-cell.component.html',
  styleUrls: ['./tracker-cell.component.scss'],
})
export class TrackerCellComponent implements OnInit, OnDestroy {
  @Input() tracker: TrackerCellModel;
  @Input() isNewPatientGroup = false;
  @Output() toggle = new EventEmitter<boolean>();
  @Output() deleteAction = new EventEmitter();
  @Output() editAction = new EventEmitter();
  private checkboxSub: Subscription;
  private tst = new Map<HTMLUListElement, boolean | undefined>();

  ngOnInit(): void {
    this.tracker.checkboxChanged = new Subject();
    this.checkboxSub = this.tracker.checkboxChanged
      .pipe(debounceTime(500))
      .subscribe(() => {
        this.toggle.emit(this.tracker.checked);
      });
  }

  ngOnDestroy(): void {
    this.checkboxSub?.unsubscribe();
  }

  onToggle() {
    this.tracker.checked = !this.tracker.checked;
    this.tracker.checkboxChanged.next();
  }

  public offsetDropdown(
    bContainer: HTMLDivElement,
    bAct: HTMLUListElement,
    height: number,
  ): boolean {
    if (!this.tst.get(bAct)) {
      const pos = bAct.getBoundingClientRect();
      this.tst.set(
        bAct,
        Math.round(pos.top) - bContainer.offsetTop + height <
          Math.round(pos.top),
      );
    }
    return this.tst.get(bAct)!;
  }
}
